module.exports = __webpack_public_path__ + "static/media/greenbagImg.548d4319.png";